<template>
  <div>
    <!--
      Ocultado por solicitação do Anchisio

      <div class="px-3 bg-gray-200" style="padding: 1px 0">
        <v-icon size="18">$CalendarStarFourPoints</v-icon>
        <span class="ml-1 font-15 font-weight-medium">Eventos</span>
      </div>
     -->

    <v-tabs v-model="tab_ativo" centered>
      <v-tab>Eventos</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab_ativo">
      <v-tab-item>
        <EventoSazonal />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import EventoSazonal from './SazonalidadeFinal/TelaInicial/Index.vue';
export default {
  components: { EventoSazonal },
  data: () => ({
    tab_ativo: null,
  }),
}
</script>

<style>

</style>
